import React from 'react'
import styles from './index.less'

interface ParmsProps {
    text1: string
    focusText: string
    text2?: string
}

export default React.memo(({ text1, focusText, text2 }: ParmsProps) => {
    return (
        <span>
            {text1}
            <span className={styles.red}>{focusText}</span>
            {text2}
        </span>
    )
})
